(function($) {
  "use strict";

  $(document).on('click', '.changeImageLink', function(e) {
    e.preventDefault();
    $('#imageChangeModal form').attr('action', '/invoice_items/' + $(this).data('id'));
  });

  $(document).on('show.bs.modal', '#trialUpdateModal', function(event) {
    var $link = $(event.relatedTarget);
    var shopId = $link.attr('data-shop-id');
    var trialEndDate = $link.attr('data-trial-end-date') || '';
    $('#trialUpdateForm').attr('action', '/managecomics_shops/' + shopId);
    var input = document.getElementById('trial_end_date_input');
    if (input) {
      if (input._flatpickr) {
        if (trialEndDate) {
          input._flatpickr.setDate(trialEndDate, true);
        } else {
          input._flatpickr.clear();
        }
      } else {
        input.value = trialEndDate;
      }
    }
  });

  $(document).on('ready turbolinks:load', function() {
    flatpickr(".datepicker", {})
  });

})(jQuery); // End of use strict
